/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('attributes', {
    templateUrl: 'app/shared/attributes/Attributes.html',
    controller: Attributes,
    bindings: {
      items: '<'
    }
  });

function Attributes($sce) {
  var $this = this;
  $this.$sce = $sce;
}

Attributes.prototype = {
  $onInit: function () {
    this.items = this.parseItems(this.items);
  },

  parseItems: function (items) {
    var result = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var iconClass = this.$sce.trustAsHtml(item.icon.toString());
      var text = this.$sce.trustAsHtml(item.text.toString());

      result.push({icon: iconClass, text: text});
    }

    return result;
  }
};
